/** Firestore path helpers — single source of truth for collections. */

/** Document id under `fiscalPeriods/{periodId}/budget/{budgetId}`. */
export const BUDGET_DOC_ID = 'main';

export function orgPeriodBudgetPath(orgId: string, periodId: string): string {
  return `${orgPath(orgId)}/fiscalPeriods/${periodId}/budget/${BUDGET_DOC_ID}`;
}

export function orgPath(orgId: string): string {
  return `organizations/${orgId}`;
}

export function orgSettingsPath(orgId: string): string {
  return `${orgPath(orgId)}/settings/main`;
}

export function orgAccountsPath(orgId: string): string {
  return `${orgPath(orgId)}/accounts`;
}

export function orgJournalEntriesPath(orgId: string): string {
  return `${orgPath(orgId)}/journalEntries`;
}

export function orgAuditLogsPath(orgId: string): string {
  return `${orgPath(orgId)}/auditLogs`;
}

export function userProfilePath(uid: string): string {
  return `users/${uid}`;
}
